import React from 'react'
import ActivityProfilesList from '../ActivityProfilesList'

export default function InterestSent() {
    return (
        <ActivityProfilesList
            title={'Interests Sent'}
            url={'sendinterest'}
        />
    )
}

